export const bg = [
    '#990033', '#a477c4', '#3498db', '#1abc9c','#55e08f','#fff054','#ef5523','#fe374a','#baa891','#ad5f43'
];

export const fg = [
    '#FFFFFF', '#FFFFFF', '#FFFFFF', '#000000','#000000','#000000','#FFFFFF','#FFFFFF','#000000','#FFFFFF'
];